import Ticket from 'src/interfaces/api/Ticket';
import { useEffect, useState } from 'react';
import Site from 'src/interfaces/api/Site';
import useSite from 'src/hooks/api/useSite';
import { unique } from 'src/utils/ArrayUtils';

export default (tickets: Ticket[]) => {
  const [sites, setSites] = useState<Site[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { getBatch } = useSite();

  useEffect(() => {
    const cachedIds = sites.map((site) => site.id);
    let sitesIds = unique(tickets.map((ticket) => ticket.siteId));
    sitesIds = sitesIds.filter((id) => id && !cachedIds.includes(id));

    if (sitesIds.length > 0 && !loading) {
      setError(undefined);
      setLoading(true);
      getBatch(sitesIds as string[])
        .then((collection) => {
          setSites([...sites, ...collection.items]);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }
  }, [tickets]);

  return { error, loading, sites };
};
